import LogUtils from "./LogUtils";
import MsgUtils from "./MsgUtils";
import ValidationUtils from "./ValidationUtils";

class VisualizationUtils {

  constructor() {
    this.TAG = "VisualizationUtils";
    this.logUtils = new LogUtils();
    this.msgUtils = new MsgUtils();
    this.txts = this.msgUtils.getTxts();
    this.msgs = this.msgUtils.getMsgs();
    this.validationUtils = new ValidationUtils();
  }

  fetchPinMsgWithParams(info) {
    try {
      if (!info?.description) return null;

      let msg = `${info.description}.\n`;

      if (info.seriousnessScore) {
        msg += `${this.getVectorSeriousnessDescription(info.seriousnessScore)}.\n`;
      }

      let contentString = '<div className="marker-info-window">';
      contentString += `<p>${msg}</p>`;
      contentString += `<a href="${info?.infoURL}">Ver detalhes</button>`;
      contentString += '</div>';

      return contentString;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unable to fetchPinsMsgWithParams", err);
    }
    return null;
  }

  getVectorSeriousnessDescription(seriousnessScore) {
    try {
      if (!this.isValidSeriousnessScore(seriousnessScore)) return "";

      if (seriousnessScore < 0.3) {
        return this.msgs.MSG_VECTOR_FOCUS_SERIOUSNESS_MILD;
      } else if (seriousnessScore < 0.7) {
        return this.msgs.MSG_VECTOR_FOCUS_SERIOUSNESS_MODERATE;
      } if (seriousnessScore <= 1) {
        return this.msgs.MSG_VECTOR_FOCUS_SERIOUSNESS_HARD;
      }
    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unable to getVectorSeriousnessDescription", err);
    }
    return "";
  }

  getVectorSeriousnessColors(seriousnessScore, themeGradientColors) {
    try {
      if (!this.isValidSeriousnessScore(seriousnessScore)) return null;

      var colors = null;

      if (seriousnessScore < 0) {
        colors = themeGradientColors.l0;
      } else if (seriousnessScore === 0) {
        colors = themeGradientColors.l1;
      } else if (seriousnessScore < 0.1) {
        colors = themeGradientColors.l2;
      } else if (seriousnessScore < 0.2) {
        colors = themeGradientColors.l3;
      } else if (seriousnessScore < 0.3) {
        colors = themeGradientColors.l4;
      } else if (seriousnessScore < 0.4) {
        colors = themeGradientColors.l5;
      } else if (seriousnessScore < 0.5) {
        colors = themeGradientColors.l6;
      } else if (seriousnessScore < 0.6) {
        colors = themeGradientColors.l7;
      } else if (seriousnessScore < 0.7) {
        colors = themeGradientColors.l8;
      } else if (seriousnessScore < 0.8) {
        colors = themeGradientColors.l9;
      } else if (seriousnessScore < 0.9) {
        colors = themeGradientColors.l10;
      } else if (seriousnessScore <= 1) {
        colors = themeGradientColors.l11;
      }
      return colors;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unable to getVectorSeriousnessColors", err);
    }

    return null;
  }

  isValidSeriousnessScore(score) {
    return !((score < 0) || (score > 1));
  }

}

export default VisualizationUtils;